import GjwCheckboxGroup from './src/GjwCheckboxGroup'

GjwCheckboxGroup.install = function(Vue) {
  Vue.component(GjwCheckboxGroup.name, GjwCheckboxGroup)
}

export default GjwCheckboxGroup
